/* eslint-disable @typescript-eslint/class-literal-property-style */
/* eslint-disable no-mixed-spaces-and-tabs */
import { IPlugin, IPluginManager } from './pluginInterface';
import * as Mobx from 'mobx';
import adjustAlign, { ChildActionType } from './plugins/adjustAlign';
import { ISelectionService } from '@src/slide/application/service/selection/selection-service.interface';
import { IElementBaseModel } from '../element-modeles/Interface/base/element-base-model.interface';
import { ISlideModel } from '../element-modeles/Interface/slide-model.interface';
import { IBaseModel } from '../element-modeles/Interface/base/base-model.interface';
import { UIModelType } from '../element-modeles/constant';

const ID_PLUGIN = 'plugin';
export default class PluginManager implements IPluginManager {
    private static singletonRef: PluginManager;

    public static getInstance(): PluginManager {
        if (!PluginManager.singletonRef) {
            PluginManager.singletonRef = new PluginManager();
        }
        return PluginManager.singletonRef;
    }
    private selectionService: ISelectionService;
    private plugins: Map<string, string>;

    public constructor() {
        this.plugins = new Map();
	    // fontsize
        // this._plugins['adjustFontSize'] = adjustFontSize;
        // align
        this.plugins[ChildActionType.ALIGN] = adjustAlign;
        // this._plugins['testPlugin'] = testPlugin;
    }
    public initWithStore = (selectionService: ISelectionService) => {
        this.selectionService = selectionService;
    };

    public handleAction(type: string, id: string, obj: any) {
        if (typeof obj === 'string' && obj.startsWith(ID_PLUGIN)) {
            return this.innerHandleAction(obj, obj, type);
        }
        if (id) {
            return this.innerHandleAction(id, obj, type);
        }
        return false;
    }

    public innerHandleAction(id: string, obj: any, type: string): boolean {
        const idParam = id.split('|');
        if (idParam.length > 1 && idParam[0] === ID_PLUGIN && this.plugins[idParam[1]]) {
            const [, pluginName, ...param] = idParam;
            this.call(pluginName, {
                idParam: param,
                objParam: obj,
                type,
            });
            return true;
        }
        return false;
    }

    public call(pluginName: string, param: any) {
        const pluginClass = this.plugins[pluginName];
	    // eslint-disable-next-line new-cap
	    const plugin: IPlugin = new pluginClass();
        plugin?.run(this, param);
    }

    public deepClone(obj: any): any {
        if (obj) {
            return JSON.parse(JSON.stringify(Mobx.toJS(obj)));
        }
        return null;
    }
    public selection() {
        const selectedArray = [...this.selectionService.selectedElements.selectedArray || []];
        return selectedArray;
    }

    public get currentSlide(): any {
        return null;
    }

    public updateElements(elements: IElementBaseModel[]) {
        const modifiedSlides: ISlideModel[] = [];
        elements.forEach((el) => {
	        const ele = el;
            let foundSlide = false;
            modifiedSlides.forEach((slide) => {
	            if (slide === this.getSlideModelFromElementModel(ele)) {
                    slide.willUpdateElement(ele);
                    foundSlide = true;
                }
            });
            if (!foundSlide) {
                const slide = this.getSlideModelFromElementModel(ele);
                slide?.willUpdateElement(ele);
                slide && modifiedSlides.push(slide);
            }
        });
        modifiedSlides.forEach((slide) => {
            slide?.updateModifiedElements();
        });
    }

    private getSlideModelFromElementModel(ele: IElementBaseModel | undefined): ISlideModel | null {
        if (!ele) {
            return null;
        }
        let cur: IBaseModel | null = ele;
        while (cur && ![UIModelType.SLIDE, UIModelType.LAYOUT, UIModelType.MASTER].includes(cur.type)) {
            cur = cur.parent;
        }
        return cur as ISlideModel | null;
    }
}
